import styled from 'styled-components';

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}

const Button = styled.button<ButtonProps>`
  padding: 1rem 1rem;
  margin-right: 10px;
  border-radius: 0.25rem;
  border: 1px solid transparent;
  cursor: pointer;
  font-weight: 500;

  ${(props) =>
    props.variant === 'outline'
      ? `
        background-color: transparent;
        color: var(--text-color);
        border-color: #ccc;
      `
      : `
        background-color: var(--secondary-color); /* #007bff; */
        color: white;
      `}

  ${(props) =>
    props.size === 'sm'
      ? `
        padding: 0.25rem 0.5rem;
        font-size: 0.8rem;
      `
      : props.size === 'lg'
      ? `
        padding: 1rem 2rem;
        font-size: 1.2rem;
      `
      : `
        padding: 0.5rem 1rem;
        font-size: 1rem;
      `}

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export { Button };
